
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';
import { ERROR_KEYS, ERROR_MESSAGES } from '@helpers/validators/errors';
import { ErrorDisplayMode } from '@models/interfaces/configuration/DynamicForm.interface';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-control-errors',
    imports: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './control-errors.component.html',
    styleUrl: './control-errors.component.css'
})
export class ControlErrorsComponent implements OnInit, OnDestroy {
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly unsubscribe$ = new Subject<void>();
  public readonly ERROR_MESSAGES = ERROR_MESSAGES;

  @Input() control!: NgControl | null;
  @Input() errorDisplayMode: ErrorDisplayMode | undefined = ErrorDisplayMode.Always;

  ngOnInit(): void {
    this.control?.control?.events
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => {
        this.cdr.markForCheck();
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  get errors(): ERROR_KEYS[] {
    if (
      !this.control || 
      !this.control.errors
    ) return [];

    return Object.keys(this.control.errors) as ERROR_KEYS[];
  }
  
}
